import { Link } from 'react-router-dom';

export default function LoginPage() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 pt-8 pb-16">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-extrabold text-text-primary mb-2">登录</h1>
          <p className="text-sm text-text-secondary">欢迎回到赛场</p>
        </div>

        <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-6">
          {/* Email */}
          <div className="mb-4">
            <label className="block text-xs font-medium text-text-secondary mb-1.5">邮箱</label>
            <input type="email" placeholder="your@email.com" className="w-full h-10 px-3 rounded-btn bg-panel-mid/40 border border-border-dark text-sm text-text-primary placeholder:text-text-disabled focus:border-arena-blue focus:outline-none transition-colors" />
          </div>

          {/* Password */}
          <div className="mb-2">
            <label className="block text-xs font-medium text-text-secondary mb-1.5">密码</label>
            <input type="password" placeholder="Enter your password" className="w-full h-10 px-3 rounded-btn bg-panel-mid/40 border border-border-dark text-sm text-text-primary placeholder:text-text-disabled focus:border-arena-blue focus:outline-none transition-colors" />
          </div>

          <div className="text-right mb-5">
            <span className="text-xs text-text-disabled hover:text-arena-blue cursor-pointer transition-colors">忘记密码？</span>
          </div>

          <button className="w-full h-10 rounded-btn bg-arena-blue text-white text-sm font-bold hover:brightness-110 transition-all mb-4">登录</button>

          <div className="flex items-center gap-3 mb-4">
            <div className="flex-1 h-px bg-border-dark" />
            <span className="text-[11px] text-text-disabled">或</span>
            <div className="flex-1 h-px bg-border-dark" />
          </div>

          <div className="grid grid-cols-3 gap-2 mb-5">
            {['微信', 'QQ', 'GitHub'].map((p) => (
              <button key={p} className="h-9 rounded-btn border border-border-dark text-xs text-text-secondary hover:border-arena-blue/40 hover:text-text-primary transition-all">{p}</button>
            ))}
          </div>

          <p className="text-center text-xs text-text-disabled">
            还没有账号？<Link to="/register" className="text-arena-blue hover:underline">立即注册</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
